export default __webpack_public_path__ + "static/media/noItem.ab193e6f.svg";